import { useMemo } from "react";

import "../theme/Indicadores.css";
import numbro from "numbro";

import { icons } from "../const/icons";
import { SkeletonOrdersCard } from "./SkeletonOrdersCard";

export const TableOrders = ({ ordersData, isLoading = false, hasError = false }) => {
  const calculations = useMemo(() => {
    // Si no hay datos o hay error, retornar valores en cero
    if (!ordersData || hasError) {
      return {
        ordenesReal: "0",
        ordenesPtto: "0",
        ordenesAA: "0",
        ordenesPttoAvg: 0,
        ordenesAAAvg: 0,
      };
    }

    const { fnordenes_real = 0, fnordenes_ppto = 0, fnordenes_real_aa = 0 } = ordersData;

    const formatValue = (value) =>
      value === 0 ? "0" : numbro(Math.round(value)).format({ thousandSeparated: true });

    const calcPercentage = (real, compare) =>
      compare === 0 ? 0 : Math.round((real * 100) / compare);

    return {
      ordenesReal: formatValue(fnordenes_real),
      ordenesPtto: formatValue(fnordenes_ppto),
      ordenesAA: formatValue(fnordenes_real_aa),
      ordenesPttoAvg: calcPercentage(fnordenes_real, fnordenes_ppto),
      ordenesAAAvg: calcPercentage(fnordenes_real, fnordenes_real_aa),
    };
  }, [ordersData, hasError]);

  // Solo mostrar skeleton durante carga
  if (isLoading) {
    return <SkeletonOrdersCard />;
  }

  // Siempre mostrar la tarjeta con datos (reales o en cero)
  return (
    <div className="container-table-sale-right">
      <div className="box-top-table-sale-right">
        <div className="box-sale-icon-right">
          <img className="IconImage" src={icons.orders} alt="Órdenes" />
          <div className="title-top-table-indicadores">Transaciones/Ordenes</div>
        </div>
        <div className="title-top-table-indicadores-real">Real</div>
        <div className="text-tota-real">{calculations.ordenesReal}</div>
      </div>

      <div className="box-body-table-sale-right">
        <div className="item-box-table-sales1-right">
          <span className="text-vs">Vs Ptto</span>
          <p className="text-porcent">{calculations.ordenesPttoAvg}%</p>
          <span className="text-presupues">{calculations.ordenesPtto}</span>
        </div>

        <div className="item-box-table-sales3-right">
          <span className="text-vs">Vs AA</span>
          <p className="text-porcent">{calculations.ordenesAAAvg}%</p>
          <span className="text-presupues">{calculations.ordenesAA}</span>
        </div>
      </div>
    </div>
  );
};
